import { ComponentWithCustomElement } from 'bloko/common/helpers/types';

/**
 * По умолчанию memo возвращает NamedExoticComponent / MemoExoticComponent и теряет информацию о дженериках.
 * Эта перегрузка позволяет сохранить дженерики в результирующем компоненте.
 *
 * https://github.com/DefinitelyTyped/DefinitelyTyped/issues/37087
 */
declare module '@types/react' {
    function memo<P extends ComponentWithCustomElement>(
        Component: P,
        propsAreEqual?: (prevProps: Readonly<Parameters<P>[0]>, nextProps: Readonly<Parameters<P>[0]>) => boolean
    ): P;
}

/**
 * По умолчанию forwardRef возвращает ForwardRefExoticComponent и теряет информацию о дженериках.
 * Эта перегрузка позволяет сохранить дженерики в результирующем компоненте.
 */
declare module 'react' {
    function forwardRef<T, P>(
        render: (props: P, ref: ForwardedRef<T>) => ReactElement | null
    ): (props: P & RefAttributes<T>) => ReactElement | null;
}
